module.exports = __webpack_public_path__ + "static/media/SMCHome.c83e2ba2.jpg";